import {charcoal} from '../sass/base/_exports.sass';
import type {IconBase} from '../types/global';
import {getColors} from '../utils/styles';

const colors = getColors();

export const SortByIcon = ({color = charcoal, ratio = 1, className}: IconBase) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  const colorValue = (colors[color] as string) || charcoal;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Sort by"
    >
      <path
        fill={colorValue as string}
        d="M9.6 22.4H3.2l9.6 9.6V0H9.6Zm9.6 9.6h3.2V9.6h6.4L19.2 0Z"
      />
    </svg>
  );
};
